export const apiUri = process.env.VUE_APP_API_URL;
export const authUri = process.env.VUE_APP_AUTH_URL;
export const clientId = process.env.VUE_APP_CLIENT_ID;
export const logoutUri = process.env.VUE_APP_LOGOUT_URL;
export const profileUri = process.env.VUE_APP_PROFILE_URL;
export const authCallbackUri = process.env.VUE_APP_AUTH_CALLBACK_URL;
export const serviceTokenUri = process.env.VUE_APP_SERVICE_TOKEN_URL;

export const dateTimeFormat = "YYYY-MM-DD HH:mm";
